import {AoaSheet, AxisMapped, ReportSheet, YAxisID} from "interfaces/report";
import {chain} from "lodash";
import {Line} from "react-chartjs-2";
import numeral from "numeral";

interface Props {
    sheet: ReportSheet<AxisMapped>;
}

export const LineChart = ({ sheet }: Props) => {
    sheet.yAxis = sheet.yAxis.filter((item) => !item.hide && item.active);

    const mergedYValue = chain(sheet.yAxis)
        .map("value")
        .uniq()
        .join(" | ")
        .value();

    const data = {
        labels: sheet.xAxis.map((item) => item.value),
        datasets: sheet.yAxis
            .filter((item) => !item.hide && item.active)
            .map((item) => {
                const color = item.color;
                const data = sheet.data
                    .find((items) => items[0] === item.value)
                    ?.slice(1) as AoaSheet;

                return {
                    data: data,
                    borderColor: color,
                    label: item.value,
                    backgroundColor: color,
                };
            }),
    };

    return (
        <Line
            options={{
                scales: {
                    y: {
                        ticks: {
                            // Include a dollar sign in the ticks
                            callback: function(value, index, ticks) {
                                const unit = sheet.yAxis.find((axis) => axis.yAxisID === YAxisID.Y)?.unit;
                                if (unit === '%') {
                                    return numeral(value).format('0%');
                                } else {
                                    return numeral(value).format(`${unit}0.0a`);
                                }
                            }
                        },
                        title: {
                            display: false,
                            text: mergedYValue,
                        },
                    },
                },
                responsive: true,
                plugins: {
                    datalabels: {
                        display: false,
                    },
                    tooltip: {
                        callbacks: {
                            title(tooltipItems) {
                                return '';
                            },
                            label(tooltipItem) {
                                return `${tooltipItem.dataset.label}\r\n${tooltipItem.formattedValue}`;
                            },
                        },
                    },
                    legend: {
                        display: false,
                    },
                },
            }}
            data={data}
        />
    );
};
